import { Injectable } from '@angular/core';
import { DataStateChangeEventArgs, DataSourceChangedEventArgs } from '@syncfusion/ej2-angular-grids';
import { HttpBackend, HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Observable, throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import { Subject } from 'rxjs/Subject';
import { LocalStorageService } from '../localStorage/local-storage.service';


@Injectable({
    providedIn: 'root'
})
export class ChatBotService extends Subject<DataStateChangeEventArgs>  {
    private httpClient: HttpClient;
    constructor(private handler: HttpBackend, private http: HttpClient, private storageService: LocalStorageService) {
        super();
        this.httpClient = new HttpClient(handler);
    }

    handleError(error: HttpErrorResponse) {
        let errorMessage = '';
        if (error.error instanceof ErrorEvent) {
            errorMessage = `Error: ${error.error.message}`;
        } else {
            errorMessage = error.error?.message || `Error Code: ${error.status}\nMessage: ${error.message}`;
        }
        console.log("Error:", errorMessage);
        return throwError(errorMessage);
    }

    //Get All changeRequests by Id Get
    getChatbotResponse(query: any): Observable<Object> {
        return this.http.post(`${environment.apiUrl}/ai/query`, query);
    }

}